import { QUALITY_EVENTS } from "./constants"

export const emitVisibleEndpointsChanged=(source,oldEndpoints,newEndpoints)=>{
    // console.error("Emit endpoints chnaged")
    window.dispatchEvent(new CustomEvent(QUALITY_EVENTS.VISIBLE_ENDPOINTS_CHANGED,{detail:{source,oldEndpoints,newEndpoints}}))
}
